import React from "react";
import { Trans } from "@lingui/react/macro";
import { Button } from "@silversea-ssc/ui-components-react";
import { FycLinkCtaFragment } from "types/graphql-types";
import { SharedButtonProps } from "../PageBuilderButtonCTA";
import { buildFycLinkCTAUrl } from "./buildFycLinkCTAButtonUrl";
import { toButtonVariantProps } from "../buttons";
import { useLanguage } from "src/utils/localization/languages/I18nContext";

type FycLinkCTAButtonProps = FycLinkCtaFragment & SharedButtonProps;
const FycLinkCTAButtonProps: React.FC<FycLinkCTAButtonProps> = ({
  variant,
  label,
  ...props
}) => {
  const language = useLanguage();
  const localizedUrl = buildFycLinkCTAUrl(props, language);
  const defaultCTALabel = <Trans id="cta-discover-more">Discover more</Trans>;
  const variantOrDefault = toButtonVariantProps(variant, "primary");

  return (
    <Button
      {...props}
      renderAs="a"
      {...variantOrDefault}
      href={localizedUrl}
      dataContentPiece="discover_more"
    >
      {label?.localized || defaultCTALabel}
    </Button>
  );
};

export default FycLinkCTAButtonProps;
